var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.$route.path == '/join-snkrhud-community')?_c('nav'):_c('Navigation',{class:{
      'black-nav': _vm.$route.path == '/blog',
    }}),_c('router-view'),_c('FooterContent',{class:{
      'remove-btn': _vm.$route.path == '/blog'
    }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }